<template>
  <div class="filter-container">
    <b-field horizontal :label="`${this.label}:`">
      <em>From:</em>
      <b-input type="number"
        @input="(v) => $emit('input', getResult(v, toValue))"
        :value="fromValue"/>
      <em>To:</em>
      <b-input type="number"
        @input="(v) => $emit('input', getResult(fromValue, v))"
        :value="toValue"/>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    queryKey: String,
    label: String,
    query: { type: Array, default: () => [] },
    fromKeyGetter: { type: Function, default: k => `${k}__gte` },
    toKeyGetter: { type: Function, default: k => `${k}__lte` },
  },
  computed: {
    fromValue() {
      const fromQuery = this.query.find(q => q.queryKey === this.fromKeyGetter(this.queryKey));
      return fromQuery && fromQuery.value;
    },
    toValue() {
      const toQuery = this.query.find(q => q.queryKey === this.toKeyGetter(this.queryKey));
      return toQuery && toQuery.value;
    },
  },
  methods: {
    getResult(fromValue, toValue) {
      return [{
        queryKey: this.fromKeyGetter(this.queryKey),
        value: fromValue,
        label: `${this.label} more than: ${fromValue}`,
      }, {
        queryKey: this.toKeyGetter(this.queryKey),
        value: toValue,
        label: `${this.label} less than: ${toValue}`,
      }].filter(v => v.value);
    },
  },
};
</script>


<style lang="scss" scoped>

/deep/ .field-body {
  align-items: center;
}

</style>
